import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';

export async function fetchItineraryTags(id, authHeaders) {
    const response = await fetchAndParse(`${API_URL}/s/tags/${id}`, {
        method: 'GET',
        headers: { ...jsonHeaders, ...authHeaders }
    });
    return response.results;
}
export async function addTagToItinerary(model, authHeaders) {
    return await fetchAndParse(`${API_URL}/s/tag`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(model)
    });
}
export async function deleteTagFromItinerary(body, authHeaders) {
    return await fetchAndParse(`${API_URL}/s/tag`, {
        method: 'DELETE',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(body)
    });
}
